import { createRouter, createWebHistory } from "vue-router";
import { usePostHog } from '@/composables/usePostHog';
import SignIn from "../views/signin.vue";

const routes = [
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/signin",
    name: "Signin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/signin.vue"),
  },
  {
    path: "/forgot-password/send-email",
    name: "ForgotPasswordEmail",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ForgotPassword/Email.vue"
      ),
  },
  {
    path: "/forgot-password/:token",
    name: "ForgotPasswordType",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ForgotPassword/TypePassword.vue"
      ),
  },
  {
    path: "/signup",
    name: "SignUp",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/signup.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/pricing.vue"),
  },
  {
    path: "/thank-you",
    name: "Thanks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/thanks.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Initialize PostHog
const { posthog } = usePostHog();

// Track pageviews on route changes
router.afterEach((to) => {
  posthog.capture('$pageview', {
    $current_url: window.location.href,
    path: to.path,
    name: to.name,
  });
});

export default router;
